import Api from '@/services/Api'

export default {
  show (params) {
    return Api().post('deviceMotion', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/DeviceMotionService.js